import { CommonModule, CurrencyPipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { EventComboTicket } from "@models/combo-ticket";
import { EventSpace } from "@models/space";
import {
  EventCategory,
  EventInfoResponseBody,
} from "@services/types/events-management-response.type";
import { BatchSummaryComponent } from "../../../../../../shared/components/batch-summary/batch-summary.component";
import { ButtonComponent } from "../../../../../../shared/components/button/button.component";
import { EventTicketBatch } from "../../../../../../shared/components/modal-tickets/types/ticket-batch.type";
import { EventFormModel } from "../../event-form.form";

@Component({
  selector: "app-event-summary-step",
  imports: [
    CommonModule,
    CurrencyPipe,
    ReactiveFormsModule,
    BatchSummaryComponent,
    ButtonComponent,
  ],
  templateUrl: "./event-summary-step.component.html",
  styleUrl: "./event-summary-step.component.scss",
})
export class EventSummaryStepComponent {
  @Input({ required: true }) eventForm!: FormGroup<EventFormModel>;

  @Input() ticketBatches: EventTicketBatch[] = [];
  @Input() combos: EventComboTicket[] = [];
  @Input() spaces: EventSpace[] = [];
  @Input() eventCategories: EventCategory[] = [];

  @Input() eventInfo?: EventInfoResponseBody;
  @Input() eventId?: string;
  @Input() transitionDisabledReason = "";

  @Output() submitClick = new EventEmitter<void>();
  @Output() batchesTransitioned = new EventEmitter<EventTicketBatch[]>();

  get isPrivateEvent(): boolean {
    return this.eventForm.controls.eventSummary.controls.isPrivate.value;
  }

  get isFreePrivateEvent(): boolean {
    return (
      !this.eventForm.controls.eventType.controls.isEventPaid.value &&
      this.isPrivateEvent
    );
  }

  onSubmitClick(): void {
    this.submitClick.emit();
  }

  getEventCategoryName(categoryId?: number | null): string {
    if (!categoryId) return "";
    const foundCategory = this.eventCategories.find(
      (categoryItem) => categoryItem.id === categoryId,
    );
    return foundCategory?.title ?? "";
  }
}
